import type { ManagerPermissionAction, ManagerPermissionName, ManagerPermissions } from '../context';

export function hasPermission(
    permissions: ManagerPermissions,
    permissionName: ManagerPermissionName,
    action: ManagerPermissionAction
): boolean {
    return permissions[permissionName]?.[action] ?? false;
}
